import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { VendorMemberService } from '../member-vendor.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-add-vendormember',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './add-vendor-member.component.html',
  styleUrl: './add-vendor-member.component.css',
})
export class AddVendorMemberComponent implements OnInit {
  addVendorMemberForm: FormGroup = new FormGroup({})
  isLoading: boolean = false
  submitted: boolean = false
  mode: string = 'add'
  vendormemberData: any
  isSubmitDisabled: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private vendormemberService: VendorMemberService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    public masterCommonService: MasterCommonServices,
  ) {}

  ngOnInit(): void {
    this.initializeForm()
    this.route.queryParams.subscribe((params) => {
      this.mode = params['mode'] || 'add'
      this.vendormemberData = params
      if (this.mode === 'update' || this.mode === 'view') {
        this.addVendorMemberForm.patchValue({
          id: params['id'],
          vendorId: params['vendorId'],
          memberName: params['memberName'],
          email: params['email'],
          mobile: params['mobile'],
          isWhatsApp: params['isWhatsApp'] == 'true',
          skypeId: params['skypeId'],
          telephone: params['telephone'],
          designation: params['designation'],
          isMainSeller: params['isMainSeller'] == 'true',
          pmoc: params['pmoc'],
          addedOn: params['addedOn'],
          modifiedOn: params['modifiedOn'],
        })
        this.addVendorMemberForm.markAsPristine()
        this.isSubmitDisabled = true
      }
    })
    this.masterCommonService.getAllVendors()
    
    // Subscribe to form value changes to enable/disable submit button
    this.addVendorMemberForm.statusChanges.subscribe(() => {
      this.updateSubmitButtonState()
    })
  }

  updateSubmitButtonState(): void {
    // Disable submit button if form is pristine (not modified)
    this.isSubmitDisabled = this.addVendorMemberForm.pristine
  }

  initializeForm() {
    this.addVendorMemberForm = this.formBuilder.group({
      id: [null],
      vendorId: ['', Validators.required],
      memberName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', Validators.required],
      isWhatsApp: [false],
      skypeId: [''],
      telephone: [''],
      designation: [''],
      isMainSeller: [false],
      pmoc: [null],
      addedOn: [''],
      modifiedOn: [''],
    })
  }

  submit() {
    this.submitted = true
    if (this.addVendorMemberForm.invalid) {
      return
    }
    this.isLoading = true
    let payload = this.addVendorMemberForm.value
    payload['modifiedOn'] = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    ).toISOString()
    if (this.mode === 'update') {
      this.vendormemberService.updateVendorMember(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.toastr.success(
            'Member Updated Successfully!!',
            'Updation Successful',
          )
          this.masterCommonService.getAllVendorMembers()
          // Mark form as pristine and disable submit button
          this.addVendorMemberForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    } else {
      payload['addedOn'] = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      ).toISOString()
      this.vendormemberService.addVendorMember(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.masterCommonService.getAllVendorMembers()
          this.toastr.success(
            'Member Added Successfully!!',
            'Creation Successful',
          )
          // Change mode to edit, populate ID, and disable submit button
          this.mode = 'update'
          this.addVendorMemberForm.patchValue({
            id: response?.id,
            addedOn: response?.addedOn
          })
          this.addVendorMemberForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    }
  }
}
